module.exports = __webpack_public_path__ + "static/media/hibiki-otsuki.9aecc771.jpg";